import { InterestRate } from "@canopyinc/api-docs/types/ts/InterestRate.type";

import { isRecordActiveAtTimestamp } from "./time";

export const isInterestRateActive = (rate: InterestRate) => isRecordActiveAtTimestamp(rate, new Date().toISOString());
